import { __makeTemplateObject } from 'tslib';
import styled from 'styled-components';
import { typography } from '../../../node_modules/@xstyled/system/dist/xstyled-system.es.js';
import { shouldForwardProp } from '../../should-forward-prop.js';

var Link = /*#__PURE__*/styled("a").withConfig({
  shouldForwardProp: function (prop, defaultValidtorFn) {
    return shouldForwardProp(prop) && defaultValidtorFn(prop);
  },
  displayName: "Link",
  componentId: "sc-1wdc3am-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  ", ";\n"], ["\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  ", ";\n"])), typography);
Link.defaultProps = {
  fontFamily: "normal",
  color: "text.normal"
};
var templateObject_1;

export { Link };
//# sourceMappingURL=Link.js.map
